define.alias("shared/components/shared/ui/social-profile-switcher/list", "media/components/shared/ui/social-profile-switcher/list");